import Card from 'components/Card/Card.jsx';
import Button from 'components/CustomButton/CustomButton.jsx';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Col, Grid, Navbar, Row } from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';
import auth from '../../libCustom/auth';
import axios from 'axios';
import async from 'async';
import magic from './magicReport';
import numeral from 'numeral';
import moment from 'moment';
import logo from '../../assets/img/Icono.png';
class ReportSalesIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      formData: {
        date_initial: moment().startOf('month').format('YYYY-MM-DD'),
        date_final: moment().endOf('month').format('YYYY-MM-DD'),
      },
      loading: true,
      dataChart: {
        datasets: [
          {
            label: 'Ventas ($)',
            data: [],
            fillColor: ['rgba(125,214,236,1)'],
            strokeColor: 'rgba(125,214,236,1)',
            highlightFill: 'rgba(125,214,236,1)',
            highlightStroke: 'rgba(125,214,236,1)',
          },
          {
            label: 'Comisiones',
            data: [],
            fillColor: ['rgba(125,214,236,1)'],
            strokeColor: 'rgba(125,214,236,1)',
            highlightFill: 'rgba(125,214,236,1)',
            highlightStroke: 'rgba(125,214,236,1)',
          },
        ],
        labels: [],
      },
      dataTable: {
        nombre: '',
        ventas: '',
        num_ventas: '',
        cotizaciones: '',
        num_cotizaciones: '',
        comisiones: '',
      },
      titleLoading: 'Cargando...',
    };
  }

  //TODO Toño - Revisar que funcione correctamente.
  componentWillMount() {
    var _this = this;

    _this.generateReport();
  }

  search(event) {
    let search = event.target.value;
    this.props.searchTable(search);
  }

  onChange = (path, value) => {
    var newFormData = immutable.set(this.state.formData, path, value);

    this.setState({
      formData: newFormData,
    });
  };

  generateReport = async () => {
    var _this = this;
    var authUser = auth.getCurrentUser();

    var userData = {
      labels: [],
      sales: [],
      quotations: [],
    };
    const params = {
      fields: {
        emailConfiguration: false,
        roles: false,
        firstName: true,
        lastName: true,
        id: true,
      },
      where: {
        franchiseId: authUser.franchiseId,
      },
    };

    if (auth.can('sales')) {
      params.where.id = authUser.id;
    }

    const url =
      process.env.REACT_APP_URL_API +
      '/api/users?filter=' +
      JSON.stringify(params);
    var users = await axios.get(url);

    if (users.data.length === 0) {
      _this.setState({
        loading: false,
        titleLoading: 'No se encontraron registros',
      });
    }
    var dataTable = [];
    this.setState({ loading: false });
    await async.forEachOf(
      users.data,
      function (user, key, callbackUser) {
        var dataTableUser = {};

        var dateInitial = _this.state.formData.date_initial;
        var datefinish = _this.state.formData.date_final;

        dataTableUser.nombre = user.firstName;
        userData.labels[key] = user.firstName.substring(0, 9);
        var totalQuotation = 0;
        var totalSale = 0;

        magic
          .quotationUserId(user.id, dateInitial, datefinish)
          .then(function (dataQuotation) {
            totalQuotation = dataQuotation.total;
            dataTableUser.cotizaciones = 3;
            dataTableUser.num_cotizaciones = dataQuotation.count;
            userData.quotations[key] = dataQuotation.total;
            return magic.salesUserId(user.id, dateInitial, datefinish);
          })
          .then(function (dataSale) {
            totalSale = dataSale.SaleTotal;

            dataTableUser.ventas = dataSale.SaleTotal;
            dataTableUser.num_ventas = dataSale.SaleCount;
            dataTableUser.comisiones = dataSale.SaleCommissions;
            userData.sales[key] = totalSale;

            dataTable.push(dataTableUser);
            callbackUser();
          });
      },
      function () {
        var dataCharJS = {
          datasets: [
            {
              label: 'Ventas ($)',
              data: userData.sales,
              backgroundColor: [
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
                'rgb(68,180,189,74)',
              ],
            },
            {
              label: 'Cotizaciones ($)',
              data: userData.quotations,
              backgroundColor: [
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
                'rgb(73,114,177,69)',
              ],
            },
          ],
          labels: userData.labels,
        };

        _this.setState({
          loading: true,
          dataChart: dataCharJS,
          dataTable: dataTable,
        });
      },
    );
  };

  clickName = (item) => {
    const { date_initial, date_final } = this.state.formData;

    const nameSearch = item.nombre;
    const startDate = date_initial;
    const endDate = date_final;

    const url = `/#/admin/sales?nameSearch=${encodeURIComponent(
      nameSearch,
    )}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(
      endDate,
    )}`;

    window.open(url, '_blank');
  };

  render() {
    let _this = this;
    let salesTotal = 0;

    if (_this.state.dataTable[0] !== undefined) {
      _this.state.dataTable.map((items) => {
        salesTotal = items.ventas - 0 + salesTotal - 0;
      });
    }

    let allData = [];
    if (_this.state.dataTable.length > 0) {
      allData = _this.state.dataTable.sort(function (a, b) {
        return b.ventas - a.ventas;
      });
    }

    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={
                  <div>
                    {'Informe de ventas'} - {'Total Ventas'}{' '}
                    <strong>{numeral(salesTotal).format('$0,0.00')}</strong>
                    <div className="pull-right header-table">
                      <Navbar.Form pullLeft className="navbar-search-form">
                        <label style={{ fontWeight: '250' }}>Desde :</label>
                        <input
                          id="date"
                          style={{ color: '#000000' }}
                          type="date"
                          className="form-control"
                          value={_this.state.formData.date_initial}
                          onChange={(event) =>
                            this.onChange('date_initial', event.target.value)
                          }
                          name="date"
                        />
                        <label style={{ fontWeight: '250' }}>Hasta :</label>
                        <input
                          id="date"
                          style={{ color: '#000000' }}
                          type="date"
                          className="form-control"
                          value={_this.state.formData.date_final}
                          onChange={(event) =>
                            _this.onChange('date_final', event.target.value)
                          }
                          name="date"
                        />
                        <Button
                          onClick={_this.generateReport}
                          style={{
                            backgroundColor: '#69a900',
                            border: '#69a900',
                            color: '#fff',
                            fontWeight: '500',
                            width: '200px',
                          }}
                        >
                          Generar
                        </Button>
                      </Navbar.Form>
                    </div>
                  </div>
                }
                ctFullWidth
                content={
                  <div>
                    <br />
                    {this.state.loading ? (
                      <Bar
                        loading={_this.state.loading}
                        ref="chart"
                        height={80}
                        redraw={true}
                        data={_this.state.dataChart}
                      />
                    ) : (
                      <h4
                        style={{
                          textAlign: 'center',
                          marginTop: '85px',
                          marginBottom: '85px',
                        }}
                      >
                        {this.state.titleLoading}
                      </h4>
                    )}
                  </div>
                }
              />
              {this.state.loading ? (
                <div>
                  <img
                    src={logo}
                    style={{ height: '40px', marginBottom: '10px' }}
                    alt="logo"
                  ></img>
                  <span
                    style={{
                      fontSize: '20px',
                      color: '#000',
                      fontWeight: '100',
                    }}
                  >
                    Informe de Ventas
                  </span>
                  <div className="containerTable">
                    <table>
                      <thead>
                        <tr>
                          <th>Nombre</th>
                          <th width={150}>$Ventas</th>
                          <th width={150}>#Ventas</th>
                          {/* <th width={145}>$Cotizaciones</th> */}
                          <th width={150}>#Cotizaciones</th>
                          <th width={150}>$Comisiones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allData.map(function (item, key) {
                          return (
                            <tr key={key}>
                              {auth.getCurrentUser().roles.includes('admin') ? (
                                <td
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => _this.clickName(item)}
                                >
                                  {item.nombre}
                                </td>
                              ) : (
                                <td>{item.nombre}</td>
                              )}

                              <td>{numeral(item.ventas).format('$0,0.00')}</td>
                              <td>{item.num_ventas}</td>
                              <td>{item.num_cotizaciones}</td>
                              <td>
                                {numeral(item.comisiones).format('$0,0.00')}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : null}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default ReportSalesIndex;



// WEBPACK FOOTER //
// ./src/views/ReportSales/ReportSalesIndex.js